<template>
  <div class="reset-password fullheight pos-relative">
    <Card class="reset-password-wrapper centered">
      <div class="img-logo text-center">
        <img src="~@/assets/images/logo/kromnix-logo-main.png" alt="kromnix logo" width="100%">
      </div>
      <h3 class="text-center padding-b-20">Please reset your password.</h3>
      <Form ref="ResetPasswordForm" :model="formData" :rules="formRules" class="reset-password-form">
        <FormItem prop="password">
          <Input type="password" v-model="formData.password" placeholder="Password"/>
        </FormItem>
        <FormItem prop="repeat_password">
          <Input type="password" v-model="formData.repeat_password" placeholder="Confirm Password"/>
        </FormItem>
        <FormItem>
          <Button class="k-btn-1" @click="handleReset('ResetPasswordForm')" size="large" long :loading="isLoading">Reset</Button>
        </FormItem>
      </Form>
    </Card>
    <SuccessResetPassword ref="SuccessResetPassword" />
  </div>
</template>

<script>
import { resetPassword, validateResetPasswordUrl } from '@/services/auth'
import SuccessResetPassword from './SuccessResetPassword'

export default {
  components: {
    SuccessResetPassword
  },

  data () {
    const validatePasswordConfirmation = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.formData.password) {
        callback(new Error('The two input passwords do not match!'))
      } else {
        callback()
      }
    }

    return {
      isLoading: false,
      formData: {
        password: null,
        repeat_password: null
      },
      formRules: {
        password: [
          { required: true, message: 'The password cannot be empty', trigger: 'blur' },
          { type: 'string', min: 8, message: 'The password length cannot be less than 8 bits', trigger: 'blur' }
        ],
        repeat_password: [
          { validator: validatePasswordConfirmation, trigger: 'blur' }
        ]
      }
    }
  },

  mounted () {
    this.validateUrl()
  },

  methods: {
    handleReset (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.handleResetPassword()
        } else {
          this.$Message.error('Please fill in all the required fields')
        }
      })
    },
    handleResetPassword () {
      this.isLoading = true
      this.$refs.SuccessResetPassword.openModal(this.$route.params.user.split('-')[0])
      resetPassword(this.$route.params.user, this.formData).then(res => {
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to reset password: ', err)
        this.isLoading = false
      })
    },
    validateUrl () {
      validateResetPasswordUrl(this.$route.params.user).then(res => {
      }).catch(err => {
        console.log('Failed to validate url: ', err)
        this.$router.push({
          name: '404-page-not-found'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-password {
  .reset-password-wrapper {
    max-width: 500px;
    width: 100%;
    margin: 0;
    padding: 20px;
    background: #e8eaeb;
    .img-logo {
      width: 200px;
      margin: auto;
    }
    h3 {
      color: #000000;
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .reset-password-form {
      text-align: center;
      width: 300px;
      margin: auto;
    }
  }
}
</style>
